var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTelegramCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8Z",
    fill: "#34AADF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.45123 7.71994C4.45123 7.71994 7.70638 6.34894 8.83531 5.86617C9.26811 5.67308 10.7357 5.05513 10.7357 5.05513C10.7357 5.05513 11.4131 4.7848 11.3566 5.44134C11.3378 5.7117 11.1873 6.65789 11.0368 7.68134C10.811 9.12961 10.5664 10.7131 10.5664 10.7131C10.5664 10.7131 10.5288 11.1572 10.2089 11.2344C9.88905 11.3117 9.36218 10.9641 9.26811 10.8868C9.19285 10.8289 7.85691 9.95994 7.36771 9.53514C7.23598 9.41927 7.08544 9.18754 7.38651 8.9172C8.06384 8.27994 8.87298 7.48827 9.36218 6.9862C9.58798 6.75447 9.81371 6.21376 8.87298 6.87027C7.53704 7.81654 6.21992 8.7048 6.21992 8.7048C6.21992 8.7048 5.91886 8.89787 5.35439 8.72407C4.78989 8.55034 4.13134 8.3186 4.13134 8.3186C4.13134 8.3186 3.67979 8.02894 4.45123 7.71994Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramCircle);
export default __webpack_public_path__ + "static/media/telegramCircle.804bd75afd199c07fc16312a4fe0de14.svg";
export { ForwardRef as ReactComponent };